import { SsoType } from '@diritto/common/account/constants/sso.constant';

export const LoginButtonLabel = {
  [SsoType.Kakao]: '카카오로 시작하기',
  [SsoType.Naver]: '네이버로 시작하기',
  [SsoType.Twitter]: '트위터로 로그인하기',
  [SsoType.Google]: '구글로 시작하기',
  [SsoType.Apple]: 'Apple로 계속하기',
  [SsoType.Ridi]: '리디로 시작하기',
  [SsoType.Email]: '이메일로 시작하기',
};

export const LoginBasePath = {
  [SsoType.Kakao]: '/accounts/auth/kakao',
  [SsoType.Naver]: '/accounts/auth/naver',
  [SsoType.Twitter]: '/accounts/auth/twitter',
  [SsoType.Google]: '/accounts/auth/google',
  [SsoType.Apple]: '/accounts/auth/apple',
  [SsoType.Ridi]: '/accounts/auth/ridi',
  [SsoType.Email]: '/accounts/auth/email',
};
